import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import {SharedDataService} from '../shared-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {TaskSearch} from './task-search';

@Injectable()
export class TaskSearchService {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataService, private shared: SharedDataService) {
  }

  /**
   * List all taskSearchs which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.taskSearchURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(taskSearch : TaskSearch) {
    console.log('Push taskSearch to insert method of service.');
    taskSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(taskSearch));
    return this.http.post(this.config.taskSearchURL+"new", JSON.stringify(taskSearch), {headers: this.headers});
  }

  public update(taskSearch : TaskSearch) {
    console.log('Push taskSearch to update method of service.');
    taskSearch.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(taskSearch));
    return this.http.put(this.config.taskSearchURL+"id/"+taskSearch.id, JSON.stringify(taskSearch), {headers: this.headers});
  }

  public qryTaskSearch(id : number) {
    return this.http.post(this.config.taskSearchURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete taskSearch '+ id);
    return this.http.post(this.config.taskSearchURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/task/task-search.service.ts